import React, { useState, useEffect } from "react";
import { Round } from "./Round";
import { useContext } from "react";
import { GameContext } from "../GameContext";
import moment from "moment";
import { ROUND_DELAY } from "../../config";
import { useSimpleCountdown } from "../../hooks/useSimpleCountdown";
import { useHistory } from "react-router-dom";
import { PlayerContext } from "../CurrentPlayerContext";
import { getQuestionImageUrl } from "../../utils";

export const RoundManager = ({
  currentRound,
  gameData
}: {
  currentRound: number;
  gameData: any;
}) => {
  const history = useHistory();
  const game = useContext(GameContext);
  const [player, { updateRound }] = useContext(PlayerContext);
  const [round, setRound] = useState(currentRound);
  const roundIndex = round - 1;
  const roundEnd = game.roundEndTimes[roundIndex];
  const answerEnd = moment(roundEnd).subtract(ROUND_DELAY, "s");
  const questionData = gameData[roundIndex];

  // preload round images
  useEffect(() => {
    gameData.forEach((round: any, i: number) => preloadRoundImage(i));
  }, []);

  const preloadRoundImage = (roundNum: number) => {
    if (gameData[roundNum]) {
      const img = new Image();
      img.src = getQuestionImageUrl(gameData[roundNum].questionImageUrl);
    }
  };

  const nextRound = () => {
    if (round < gameData.length) {
      preloadRoundImage(round + 1);
      setRound(round + 1);
    } else {
      history.push(`/result/${game.id}`);
    }
  };
  // comment out to toggle auto advance.
  useSimpleCountdown(roundEnd, () => nextRound());

  useEffect(() => {
    updateRound(round);
  }, [round]);

  return (
    <Round
      totalRounds={gameData.length}
      round={round}
      questionData={questionData}
      answerEnd={answerEnd}
    />
  );
};
